export const maxCount = count => (count > 500 ? '500+' : count);
